import type { RouteObject } from 'react-router-dom';
import { GATE_SLOTS } from './gate-slots';

// Rutas de src/fsd/ bajo /gates. appRoutes.tsx las monta dentro de AppLayout y de AmaruGuard
// (Sec:Compuertas).
export const gatesRoutes: RouteObject[] = [
  {
    // Enlace corto: solo el movimiento. El segmento estático gana sobre `:gateId`.
    path: 'movements/:movementId',
    lazy: () =>
      import('@fsd/pages/gate-movements').then((m) => ({ Component: m.MovementRedirectPage })),
  },
  {
    path: ':gateId/movements/:movementId?',
    lazy: () =>
      import('@fsd/pages/gate-movements').then((m) => ({ Component: m.GateMovementsPage })),
  },
];

// Rutas de src/fsd/ bajo /dashboards. appRoutes.tsx las monta dentro de AppLayout y de AmaruGuard
// (Sec:MetricsViews).
export const dashboardsRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () => import('@fsd/pages/dashboards').then((m) => ({ Component: m.DashboardsPage })),
  },
  {
    path: ':masterId',
    // Los widgets de compuerta abren los modales de `features/gate-movements` por `WidgetContext`.
    lazy: () =>
      import('@fsd/pages/dashboards').then(({ DashboardEditorPage }) => ({
        Component: () => <DashboardEditorPage {...GATE_SLOTS} />,
      })),
  },
];

// Rutas de src/fsd/ bajo /dga2. appRoutes.tsx las monta dentro de AppLayout y de AmaruGuard
// (Sec:ReportesDGA).
export const dgaRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () => import('@fsd/pages/dga-reports').then((m) => ({ Component: m.DgaReportsPage })),
  },
];

// Rutas de src/fsd/ bajo /widget-catalog. appRoutes.tsx las monta dentro de AppLayout y de
// CaptaGuard.
export const widgetCatalogRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () =>
      import('@fsd/pages/widget-catalog').then((m) => ({ Component: m.WidgetCatalogPage })),
  },
];
